module.exports = __webpack_public_path__ + "static/media/Abc.9d68b63e.png";